import { Component, OnInit, ViewEncapsulation, AfterViewInit } from '@angular/core';
import { Helpers } from '../../../helpers';
import { ApiService } from '../../pages/api-service.service';
import { Router, Routes, RouterModule } from '@angular/router';
import { AuthenticationService } from '../../../auth/_services/authentication.service';

declare let mLayout: any;
@Component({
    selector: "app-header-nav",
    templateUrl: "./header-nav.component.html",
    encapsulation: ViewEncapsulation.None,
})
export class HeaderNavComponent implements OnInit, AfterViewInit {

    public _username;
    public  _email;
    constructor(public apiService: ApiService, public auth: AuthenticationService, public router: Router) {}

    ngOnInit() {
        this.loadusername();
     }

    loadusername() {
        Helpers.setLoading(true); 
        let user = JSON.parse(localStorage.getItem('currentUser'));
        if (user != null) {
            this.apiService.getUserById(user.userid).subscribe(result => {
                let d =  result
                this._email =  d['email']
                this._username = d['display_name']
                Helpers.setLoading(false);
            },
            error =>{
                this.outsession(error)
                Helpers.setLoading(false);
            } 
        );
        }
        else {
            this.logout();
        }
    }
    outsession(data) {
        if (data == 0) {
            localStorage.removeItem('currentUser');
            this.router.navigate(['/login'])
        }
    }



    logout() {
        const user = JSON.parse(localStorage.getItem('currentUser'));
        if (user) {
            localStorage.removeItem('currentUser');
            this.router.navigate(['/login']);
            this._username = '';
        }
    }


    ngAfterViewInit() {

        mLayout.initHeader();

    }

}


// WEBPACK FOOTER //
// D:/Finca/Finca UI/UI/src/app/theme/layouts/header-nav/header-nav.component.ts